"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseCreatedUpdatedFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const get_value_1 = require("./get-value");
const create_updated_1 = require("../../type-checking/create-updated");
class BaseCreatedUpdatedFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, create_updated_1.isCreatedUpdatedFieldValue)(fieldValue);
        };
        this.getEmptyValue = () => (0, get_value_1.getCreatedUpdatedFieldEmptyValue)();
    }
}
exports.BaseCreatedUpdatedFieldValueGetter = BaseCreatedUpdatedFieldValueGetter;
